import React, {Component} from 'react';
import {Button, Col, Label, Modal, ModalBody, ModalFooter, ModalHeader, Row, UncontrolledTooltip} from "reactstrap";
import Select from "../../../local_node_modules/react-select"
import {validateComponent, validateField, validateForeignCustomerPhone} from "../../../common/validation";
import {deepCopyObject, showAxiosError} from "../../../helper/helper";
import {request} from "../../../helper/APIUtils";
import Table from "../../../components/Table/Table";
import Alert from "react-s-alert";
import {showBaro} from "../../../helper/permission";
import MaskedInput from "react-text-mask";
import emailMask from "text-mask-addons/dist/emailMask";
import SweetAlert from "react-bootstrap-sweetalert";
import {ExternalCustomerMainType} from "../../../helper/enums";

class ExternalCustomerAddressInfo extends Component {
	constructor(props) {
		super(props);

		this.state = {
			page: 0,
			size: 5,
			error: {},
			initExCustAddData: '',
			addressList: [],
			deleteModal: false,
			addAddressModal: false,
			selected: 0,
			pkList: [],
			invoicePkList: [],
			despatchPkList: [],
			locationSelect: false,
			isMobile : window.innerWidth > 991 ? false : true
		};

		this.validateField = this.validateField.bind(this);
		this.validateForeignCustomerPhone = this.validateForeignCustomerPhone.bind(this);
		this.validateClass = this.validateClass.bind(this);
		this.validateMessage = this.validateMessage.bind(this);
		this.validateComponent = this.validateComponent.bind(this);
		this.isChanged = this.isChanged.bind(this);
		this.handleDelete = this.handleDelete.bind(this);
		this.updateAddressList = this.updateAddressList.bind(this);
		this.arrangeData = this.arrangeData.bind(this);
		this.cancelCurrentAddress = this.cancelCurrentAddress.bind(this);
		this.getTrStyles = this.getTrStyles.bind(this);
		this.toggleSelectedRow = this.toggleSelectedRow.bind(this);
		this.openAddAddressModal = this.openAddAddressModal.bind(this);
		this.fetchPkList = this.fetchPkList.bind(this);
		this.editAddress = this.editAddress.bind(this);
		this.onCountryChange = this.onCountryChange.bind(this);
	}

	componentDidMount() {
		let externalCustomerAddress = this.props.externalCustomerAddress;
		let externalCustomerAddressList = this.props.externalCustomerAddressList;
		let checkAddress = externalCustomerAddressList.filter((f) => f.defaultAddress === true);
		if (checkAddress !== null && checkAddress !== undefined && checkAddress.length !== 0 && (externalCustomerAddress.cityName === "" && externalCustomerAddress.citySubdivisionName === "") ){
			externalCustomerAddress = checkAddress[0];
		}
		let index = externalCustomerAddressList.map(function (item) {
			return item.recordId;
		}).indexOf(externalCustomerAddress.recordId);
		if (index === -1 && externalCustomerAddress !== null && externalCustomerAddress !== undefined) {
			index = externalCustomerAddressList.findIndex((f) => f.addressName === externalCustomerAddress.addressName);
			externalCustomerAddress = externalCustomerAddressList[index];
			this.setState({
				addressList: externalCustomerAddressList,
				selected: (index + "" + (externalCustomerAddress ? externalCustomerAddress.recordId : null))
			},() => this.locationSelect());
		} else {
			this.setState({
				addressList: externalCustomerAddressList,
				selected: (index + "" + (externalCustomerAddress ? externalCustomerAddress.recordId : null))
			},() => this.locationSelect());
		}
	}

	componentWillReceiveProps (){
		this.setState({addressList: this.props.externalCustomerAddressList})
	}

	componentDidUpdate(prevProps, prevState, snapshot) {
		if (this.props.changeExternalCustomer === true){
			this.fetchPkList(this.props.externalCustomer)
		}
	}

	validateField(e) {
		let id = e.target.id;
		let rule = e.target.dataset.vdata;
		let boundary = e.target.dataset.vlength;
		let result = validateField(rule, boundary, e.target.value);
		let error = this.state.error;
		error = Object.assign(error, {[id]: result});
		this.setState({error});
	}

	validateForeignCustomerPhone(e) {
		let id = e.target.id;
		let rule = e.target.dataset.vdata;
		let boundary = e.target.dataset.vlength;
		let result = validateForeignCustomerPhone(rule, boundary, e.target.value);
		let error = this.state.error;
		error = Object.assign(error, {[id]: result});
		this.setState({error});
	}

	validateClass(id) {
		let error = this.state.error;
		return (error[id] === undefined ? "" : (error[id].valid ? " has-success" : " has-danger"));
	}

	validateMessage(id) {
		let error = this.state.error;
		return (error[id] === undefined ? '' : (error[id].message));
	}

	validateComponent() {
		let externalCustomerAddress = deepCopyObject(this.props.externalCustomerAddress);
		let result = validateComponent(this);
		let error = {valid: true, message: ""};
		let id = "";
		for (let value in externalCustomerAddress) {
			if (value === "email") {
				if(!!externalCustomerAddress[value]) {
					id = "tEmail";
					let emailError = validateField("email", "1,255", externalCustomerAddress[value]);
					if (!emailError.valid) {
						error.valid = false;
						error.message += emailError.message;
					}
				}
			}
			if (value === "telephone") {
				if(!!externalCustomerAddress[value]) {
					id = "tTelephone";
					let phoneError;
					if (externalCustomerAddress[value].includes("_") && !(this.props.externalCustomer.externalCustomerMainType === ExternalCustomerMainType.Foreign)) {
						phoneError = validateField("phone", undefined, externalCustomerAddress[value]);
					}
					if (!(this.props.externalCustomer.externalCustomerMainType === ExternalCustomerMainType.Foreign))
						phoneError = validateField("phone", "13,13", externalCustomerAddress[value]);

					if (externalCustomerAddress[value].includes("_") && (this.props.externalCustomer.externalCustomerMainType === ExternalCustomerMainType.Foreign)) {
						phoneError = validateForeignCustomerPhone("phone", undefined, externalCustomerAddress[value]);
					}
					if (this.props.externalCustomer.externalCustomerMainType === ExternalCustomerMainType.Foreign)
						phoneError = validateForeignCustomerPhone("phone", "12,16", externalCustomerAddress[value]);

						if (!phoneError.valid) {
						error.valid = false;
						error.message += phoneError.message ;
					}
				}
			}
		}
		result.error = Object.assign(result.error, {[id]: error});
		result.valid = result.valid && error.valid;
		this.setState({
			error: result.error
		});
		return result
	}

	async addAddress() {
		let isValid = this.validateComponent();
		if (isValid.valid) {
			await this.props.addAddressToCustomer();
		} else {
			Alert.error(this.arrangeErrorMessage(), {
				position: 'top-right',
				effect: 'stackslide',
				timeout: 5000
			});
		}
		if (this.state.addressList.length < 2 && this.state.addressList.length > 0) {
			if (this.state.addressList[0].recordId === null){
				this.props.selectedAddress(this.state.addressList[0], 0)
			}
		}
	}

	closeAddAddressModal() {
		this.setState({addAddressModal: false})
	}

	saveUpdatedAddress() {
		let obj = this.props.externalCustomerAddress;
		obj.externalCustomer = this.props.externalCustomer;
		let params = {
			url: `/externalCustomer/saveExternalCustomerAddress`,
			data: obj,
			method: 'post'
		};
		request(params)
			.then(() => this.clearForm())
			.then(() => this.updateAddressList(obj))
			.catch(function (error) {
				showAxiosError(error);
			});
	}

	updateAddressList(obj) {
		let addressList = JSON.parse(JSON.stringify(this.state.addressList));
		let selectedIndex = this.state.selectedIndex;
		addressList.splice(selectedIndex, 1, obj);
		this.setState({addressList: addressList});
	}

	handleEdit(data) {
		let addressList = this.props.externalCustomerAddressList;
		let index = addressList.indexOf(data);
		let carrier = {};
		carrier.row = data;
		carrier.editAddressMode = 'active';
		carrier.index = index;
		this.props.fillAddressForm(carrier);
		this.fetchPkList(this.props.externalCustomer)
		this.setState({addAddressModal: true, locationSelect: data.manualInput !== 1});
	}

	handleDelete() {
		this.props.deleteAddress(this.state.selectedRowId);
		let addressList = JSON.parse(JSON.stringify(this.state.addressList));
		addressList.splice(this.state.selectedRowIndex, 1);
		this.setState({addressList: addressList, alert: null});
	}

	clearForm() {
		this.props.clearForm();
	}

	cancelCurrentAddress() {
		this.props.clearForm();
		this.setState({addAddressModal: false});
	}

	openDeleteModal(data,index) {
		this.setState({
			selectedRowId: data.recordId,
			selectedRowIndex: index,
			alert: (
				<SweetAlert showCancel warning
							confirmBtnText="Evet"
							cancelBtnText="Hayır"
							confirmBtnBsStyle="danger"
							cancelBtnBsStyle="default"
							title="Emin Misiniz?"
							onConfirm={() => this.handleDelete()}
							onCancel={() => this.setState({alert: null})}
				>
					Adres Silinecek!
				</SweetAlert>
			)});
	}

	isChanged(initState, input) {
		if (JSON.stringify(initState) === JSON.stringify(input)) {
			return false;
		} else {
			return true;
		}
	}

	getTrStyles(row, index) {
		return {backgroundColor: (this.state.selected === (index + "" + row.recordId) ? "#ade2ad" : "")};
	}

	toggleSelectedRow(e, row, index) {
		this.setState({selected: (index + "" + (e.target.checked ? row.recordId : null))});
		if (e.target.checked && this.props.selectedAddress) {
			this.props.selectedAddress(row, index);
		}
	}

	arrangeData(page, size) {
		this.setState({
			page: page,
			size: size,
			loading: false
		});
	}

	openAddAddressModal() {
		this.fetchPkList(this.props.externalCustomer);
		this.props.clearForm();
		this.setState({addAddressModal: true});
	}

	fetchPkList(content) {
		if (content.vknTckn) {
			let self = this;
			let params = {
				url: '/externalCustomer/fetchPkList',
				data: content.vknTckn,
				method: 'post'
			};
			request(params).then((response) => {
				let pkList = response.data;
				let invoicePkList = [];
				let despatchPkList = [];
				if (pkList.length !== 0) {
					invoicePkList = pkList.filter(pk => pk.documentType === 'Invoice');
					if (invoicePkList.length !== 0) {
						self.props.setPkAlias('postboxAlias', (this.props.externalCustomerAddress && this.props.externalCustomerAddress.postboxAlias) ? this.props.externalCustomerAddress.postboxAlias :  invoicePkList[0].aliasName);
					}

					despatchPkList = pkList.filter(pk => pk.documentType === 'DespatchAdvice');
					if (despatchPkList.length !== 0) {
						self.props.setPkAlias('despatchPostboxAlias', (this.props.externalCustomerAddress && this.props.externalCustomerAddress.despatchPostboxAlias) ? this.props.externalCustomerAddress.despatchPostboxAlias : despatchPkList[0].aliasName);
					}
				}
				self.setState({pkList: response.data, invoicePkList, despatchPkList});
			}).catch(function (error) {
				showAxiosError(error);
			});
		}
	}

	editAddress() {
		let isValid = this.validateComponent();
		if (isValid.valid) {
			this.props.editAddress();
		} else {
			Alert.error(this.arrangeErrorMessage(), {
				position: 'top-right',
				effect: 'stackslide',
				timeout: 5000
			});
		}
	}

	locationSelect() {
		let locationSelect = true;
		if(this.props.externalCustomerAddress.countryName !=="Türkiye") {
			locationSelect=false;
		}
		else {
			locationSelect = !deepCopyObject(this.state.locationSelect);
		}
		let manualInputObj = {
			target: {
				name: 'manualInput',
				value: locationSelect ? 0 : 1
			}
		};
		this.setState({
			locationSelect,
		}, () => this.props.onChangeExternalCustomerAddress(manualInputObj));
	}

	onCountryChange(e){
		this.props.onCountryChange(e);
		this.locationSelect();
	}


	arrangeErrorMessage() {
		let errorObject = deepCopyObject(this.state.error);

		let errorArray = [];

		for (let key in errorObject) {
			if (errorObject.hasOwnProperty(key)) {
				let error = {};
				if (!!errorObject[key].message && key !== 'tCity') {
					error.field = this.defineReadableFieldName(key);
					error.message = errorObject[key].message;
					errorArray.push(error);
				}
			}
		}

		this.setState({error: errorObject});

		return errorArray.map(error => '<strong>' + error.field + error.message + '</strong><br/>').join('')
	}

	defineReadableFieldName(key) {

		switch (key) {
			case 'tAddressName':
				return 'Adres Adı ';
			case 'tPostboxAlias':
				return 'e-Fatura Alıcı Etiketi ';
			case 'tDespatchPostboxAlias':
				return 'e-İrsaliye Alıcı Etiketi ';
			case 'tCountryName':
				return 'Ülke ';
			case 'tCityName':
				return 'Şehir ';
			case 'tCitySubdivisionName':
				return 'İlçe ';
			default :
				return '';
		}
	}

	render() {
		const {isMobile} = this.state;
		let externalCustomerAddress = this.props.externalCustomerAddress;
		let columns = this.props.selectedAddress ? [{
			Header: "",
			accessor: "recordId",
			sortable: false,
			Cell: (row, index) => (<input type="radio" checked={(index + "" + row.recordId === this.state.selected)}
										  onChange={(e) => this.toggleSelectedRow(e, row, index)}/>)
		}] : [];

		const headers = [
			{
				Header: "Adres Adı",
				title: "Adres Adı",
				accessor: "addressName"
			},
			{
				Header: "İlçe",
				title: "İlçe",
				accessor: "citySubdivisionName"
			},
			{
				Header: "Şehir",
				title: "Şehir",
				accessor: "cityName",
			},
			{
				Header: "Telefon",
				title: "Telefon",
				accessor: "telephone"
			},
			{
				Header: "E-posta",
				title: "E-posta",
				accessor: "email"
			},
			{
				Header: "Web Sitesi",
				title: "Web Sitesi",
				accessor: "webSite"
			},
			{
				Header: "İşlemler",
				title: "İşlemler",
				Cell: (row, index) => (
					<div>
						<button type="button" onClick={() => this.handleEdit(row)} rel="tooltip"
								className="btn btn-info btn-icon btn-sm" style={{margin: '0px'}}>
							<i className="fas fa-edit"/>
						</button>
						{row.recordId && this.props.showDeleteBtn &&
						<button type="button" onClick={() => this.openDeleteModal(row,index)} rel="tooltip"
								className="btn btn-danger btn-icon btn-sm" style={{margin: '0 0 0 2px'}}>
							<i className="fas fa-close"/>
						</button>
						}
					</div>
				)
			}
		];

		columns = columns.concat(headers);

		return (
			<div style={{margin: '0', padding: '0'}}>
				<Row>
					<Col xs='12' style={{textAlign: 'left'}}>
						<button type="button" data-toggle="tooltip" data-placement="bottom"
								disabled={ this.props.externalCustomer.vknTckn === null || this.props.externalCustomer.vknTckn === "" }
								style={{background: 'linear-gradient(rgba(159, 208, 55, 0.6), #9fd037)', marginBottom: '10px', marginTop: '20px'}}
								rel="tooltip" className="TekBtn ekle"
								onClick={this.openAddAddressModal}>Yenİ Adres Ekle
						</button>
					</Col>
				</Row>

				<Row>
					<Col xs='12'>
						<Table
							columns={columns}
							content={this.state.addressList}
							page={this.state.page}
							size={this.state.size}
							options={["5", "10", "20", "50", "100"]}
							total={this.state.addressList.length}
							fetchData={this.arrangeData}
							getTrStyles={this.getTrStyles}
						/>
					</Col>
				</Row>

				<Modal isOpen={this.state.addAddressModal} size="lg">
					<ModalHeader toggle={this.cancelCurrentAddress}>Adres Detayları</ModalHeader>
					<ModalBody id="externalCustomerModalContainer">

						{!this.props.manualCity &&
						<Row>
							<Col xs='6'>
								<Label check className="col-sm-1 form-check-label">
									<input type="checkbox" style={{marginLeft: '-5px'}} checked={!!((externalCustomerAddress.manualInput && externalCustomerAddress.manualInput === 1)||(this.props.externalCustomerAddress.countryName !=="Türkiye"))}
										   onChange={() => this.locationSelect()}/>
								</Label>
								<label className="col-sm-11" style={{marginLeft: '-5px'}}>Şehir / İlçe bilgileri el ile girilsin</label>
							</Col>
							<Col xs='6'>
								<input type="checkbox" checked={externalCustomerAddress.defaultAddress}
									   onChange={() => this.props.selectedAddressChange()}/>
								<label className="col-sm-11" style={{marginRight: '0px'}}>Varsayılan Adres Olarak İşaretle</label>
							</Col>
						</Row>}


						<Row>
							<Col xs='12' sm='12' md='12' lg='6'>
								<Row>
									<Col xs='4'>
										<label className="col-form-label">Adres Adı: </label>
									</Col>
									<Col xs='8' className={"form-group" + this.validateClass('tAddressName')}>
										<input className="form-control"
											   type="text"
											   name="addressName"
											   data-vlength="1,60"
											   id="tAddressName"
											   ref="tAddressName"
											   onBlur={this.validateField}
											   value={externalCustomerAddress.addressName || "MERKEZ"}
											   onChange={(e) => this.props.onChangeExternalCustomerAddress(e)}/>
										{this.validateMessage('tAddressName') !== "" &&
										<UncontrolledTooltip placement="right" target="tAddressName" delay={0}>
											{this.validateMessage("tAddressName")}
										</UncontrolledTooltip>}
									</Col>
								</Row>
							</Col>

							<Col xs='12' sm='12' md='12' lg='6'>
								<Row>
									<Col xs='4'>
										<label className="col-form-label">Yetkili Kişi: </label>
									</Col>
									<Col xs='8' className="form-group">
										<input className="form-control"
											   type="text"
											   name="contactPerson"
											   value={externalCustomerAddress.contactPerson}
											   onChange={(e) => this.props.onChangeExternalCustomerAddress(e)}/>
									</Col>
								</Row>
							</Col>
						</Row>

						{showBaro() ? null :
							<Row>

								<Col xs='12' sm='12' md='12' lg='6' >

									<Row>
										<Col xs='4'>
											<label className="col-form-label" style={{whiteSpace: isMobile ? 'normal' : 'nowrap'}}>e-Fatura
												Alıcı Etiketi: </label>
										</Col>

										{this.props.docType === 'EFATURA' ?
											<Col xs='8'
												 className={"form-group" + this.validateClass('tPostboxAlias')}>
												<Select
													className="select-control"
													name='postboxAlias'
													id='tPostboxAlias'
													clearable={false}
													onBlur={() => this.validateField({
														target: {
															id: 'tPostboxAlias',
															dataset: {'vdata': "required", 'vlength': "1,255"}
														}
													})}
													inputProps={{'vdata': "required", 'vlength': "1,255"}}
													ref='tPostboxAlias'
													value={externalCustomerAddress.postboxAlias}
													placeholder="Seçiniz..."
													onChange={(e) => this.props.onChangeExternalCustomerAddress({
														target: {
															value: e && e.value,
															name: 'postboxAlias'
														}
													})}
													options={this.state.invoicePkList.map(pk => ({
														value: pk.aliasName,
														label: pk.aliasName
													}))}
												/>
												{this.validateMessage('tPostboxAlias') !== "" &&
												<UncontrolledTooltip placement="right"
																	 target='tPostboxAlias'
																	 delay={0}>
													{this.validateMessage('tPostboxAlias')}
												</UncontrolledTooltip>}
											</Col>

											:

											<Col xs='8' className="form-group">
												<Select
													className="select-control"
													name='postboxAlias'
													clearable={false}
													value={externalCustomerAddress.postboxAlias}
													placeholder="Seçiniz..."
													onChange={(e) => this.props.onChangeExternalCustomerAddress({
														target: {
															value: e && e.value,
															name: 'postboxAlias'
														}
													})}
													options={this.state.invoicePkList.map(pk => ({
														value: pk.aliasName,
														label: pk.aliasName
													}))}
												/>
											</Col>}
									</Row>
								</Col>


								<Col xs='12' sm='12' md='12' lg='6' >

									<Row>
										<Col xs='4'>
											<label className="col-form-label" style={{whiteSpace: isMobile ? 'normal' : 'nowrap'}}>e-İrsaliye
												Alıcı Etiketi: </label>
										</Col>

										<Col xs='8'
											 className="form-group">
											<Select
												className="select-control"
												name='despatchPostboxAlias'
												clearable={false}
												value={externalCustomerAddress.despatchPostboxAlias}
												placeholder="Seçiniz..."
												onChange={(e) => this.props.onChangeExternalCustomerAddress({
													target: {
														value: e && e.value,
														name: 'despatchPostboxAlias'
													}
												})}
												options={this.state.despatchPkList.map(pk => ({
													value: pk.aliasName,
													label: pk.aliasName
												}))}
											/>
										</Col>
									</Row>
								</Col>
							</Row>
						}
						<Row>
							<Col xs='12' sm='12' md='12' lg='6'>
								<Row>
									<Col xs='4'>
										<label className="col-form-label">Şehir *</label>
									</Col>
									<Col xs='8' className={"form-group" + this.validateClass('tCityName')}>
										{((externalCustomerAddress.manualInput && externalCustomerAddress.manualInput === 1) || (this.props.externalCustomerAddress.countryName !== "Türkiye"))
											?
											<input className="form-control"
												   type="text"
												   name="cityName"
												   data-vlength="1,255"
												   id="tCityName"
												   ref="tCityName"
												   onBlur={this.validateField}
												   value={externalCustomerAddress.cityName}
												   onChange={(e) => this.props.onChangeExternalCustomerAddress(e)}/>

											:
											<Select
												clearable={false}
												className="select-control"
												name="cityName"
												id="tCityName"
												onBlur={() => this.validateField({
													target: {
														id: "tCityName",
														dataset: {'vlength': "1,255"},
														value : externalCustomerAddress.cityName
													}
												})}
												inputProps={{'vdata': "cityName", 'vlength': "1,255"}}
												ref="tCityName"
												value={externalCustomerAddress.cityName}
												placeholder="Seçiniz..."
												onChange={(e) => this.props.onCityChange(e)}
												options={this.props.cities.map(city => ({
													value: city.cityName,
													label: city.cityName
												}))}
											/>
										}
										{this.validateMessage('tCityName') !== "" &&
										<UncontrolledTooltip placement="right" target="tCityName" delay={0}>
											{this.validateMessage("tCityName")}
										</UncontrolledTooltip>}
									</Col>
								</Row>
							</Col>
							<Col xs='12' sm='12' md='12' lg='6'>
								<Row>
									<Col xs='4'>
										<label className="col-form-label">İlçe *</label>
									</Col>
									<Col xs='8' className={"form-group" + this.validateClass('tCitySubdivisionName')}>
										{((externalCustomerAddress.manualInput && externalCustomerAddress.manualInput === 1) || (this.props.externalCustomerAddress.countryName !== "Türkiye"))
											?
											<input className="form-control"
												   type="text"
												   name="citySubdivisionName"
												   data-vlength="1,255"
												   id="tCitySubdivisionName"
												   ref="tCitySubdivisionName"
												   onBlur={this.validateField}
												   value={externalCustomerAddress.citySubdivisionName}
												   onChange={(e) => this.props.onChangeExternalCustomerAddress(e)}/>
											:
											<Select
												clearable={false}
												className="select-control"
												name="citySubdivisionName"
												id="tCitySubdivisionName"
												onBlur={() => this.validateField({
													target: {
														id: "tCitySubdivisionName",
														dataset: {'vdata': "required", 'vlength': "1,255"},
														value:externalCustomerAddress.citySubdivisionName
													}
												})}
												inputProps={{'vdata': "citySubdivisionName", 'vlength': "1,255"}}
												ref="tCitySubdivisionName"
												value={externalCustomerAddress.citySubdivisionName}
												placeholder="Seçiniz..."
												onChange={(e) => this.props.onCitySubdivisionChange(e)}
												options={this.props.getSubdivisionsForCity(externalCustomerAddress.cityName)}
											/>
										}
										{this.validateMessage('tCitySubdivisionName') !== "" &&
										<UncontrolledTooltip placement="right" target="tCitySubdivisionName" delay={0}>
											{this.validateMessage("tCitySubdivisionName")}
										</UncontrolledTooltip>}
									</Col>
								</Row>
							</Col>
						</Row>

						<Row>
							<Col xs='12' sm='12' md='12' lg='6'>
								<Row>
									<Col xs='4'>
										<label className="col-form-label">Ülke *</label>
									</Col>
									<Col xs='8' className={"form-group" + this.validateClass('tCountryName')}>
										<Select
											className="select-control"
											name="countryName"
											id="tCountryName"
											inputProps={{'vdata': "required"}}
											ref="tCountryName"
											value={externalCustomerAddress.countryName}
											placeholder="Seçiniz..."
											clearable={false}
											onChange={ (e) => this.onCountryChange(e)}
											options={this.props.countries ? this.props.countries.map(country => ({
												value: country.longNameTr,
												label: country.longNameTr})) : [{label:'Türkiye', value:'Türkiye'}]}
										/>
										{this.validateMessage('tCountryName') !== "" &&
										<UncontrolledTooltip placement="right" target="tCountryName" delay={0}>
											{this.validateMessage("tCountryName")}
										</UncontrolledTooltip>}
									</Col>
								</Row>
							</Col>

							<Col xs='12' sm='12' md='12' lg='6'>
								<Row>
									<Col xs='4'>
										<label className="col-form-label" style={{whiteSpace: 'nowrap'}}>Web Sitesi</label>
									</Col>
									<Col xs='8' className="form-group">
										<input className="form-control"
											   type="text"
											   name="webSite"
											   value={externalCustomerAddress.webSite}
											   onChange={(e) => this.props.onChangeExternalCustomerAddress(e)}/>
									</Col>
								</Row>
							</Col>
						</Row>

						<Row>
							<Col xs='12' sm='12' md='12' lg='6'>
								<Row>
									<Col xs='4'>
										<label className="col-form-label">E-Posta</label>
									</Col>
									<Col xs='8' className="form-group">
										<input className="form-control"
											   type="text"
											   name="email"
											   id="tEmail"
											   ref="tEmail"
											   onBlur={this.validateField}
											   value={externalCustomerAddress.email}
											   onChange={(e) => this.props.onChangeExternalCustomerAddress(e)}
											   onKeyDown={(e)=>{
												   if (e.keyCode == 32) {
													   e.preventDefault();
												   }
											   }}
										/>
									</Col>
								</Row>
							</Col>

							<Col xs='12' sm='12' md='12' lg='6'>
								<Row>
									<Col xs='4'>
										<label className="col-form-label">Telefon</label>
									</Col>
									<Col className={"form-group" + this.validateClass('tTelephone')} xs='8'>
										{(this.props.externalCustomer.externalCustomerMainType === ExternalCustomerMainType.Foreign) ?
											<input className="form-control"
												   placeholder="____________"
												   type="text"
												   id="tTelephone"
												   ref="tTelephone"
												   inputProps={{vdata: "phone", vlength: '12,16'}}
												   guide={true}
												   name="telephone"
												   data-vlength="12,16"
												   data-vdata="phone"
												   onBlur={this.validateForeignCustomerPhone}
												   value={externalCustomerAddress.telephone}
												   onChange={(e) => this.props.onChangeExternalCustomerAddress(e)}/>
										:
											<MaskedInput className="form-control"
													 mask={['+', '9', '0', /[1-9]/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/]}
													 placeholder="+90__________"
													 type="text"
													 id="tTelephone"
													 ref="tTelephone"
													 inputProps={{vdata: "phone", vlength: '13,13'}}
													 guide={true}
													 name="telephone"
													 data-vlength="13,13"
													 data-vdata="phone"
													 onBlur={this.validateField}
													 value={externalCustomerAddress.telephone}
													 onChange={(e) => this.props.onChangeExternalCustomerAddress(e)}/>}
										{this.validateMessage('tTelephone') !== "" &&
										<UncontrolledTooltip placement="right" target="tTelephone" delay={0}>
											{this.validateMessage("tTelephone")}
										</UncontrolledTooltip>}
									</Col>
								</Row>
							</Col>
						</Row>

						<Row>
							<Col xs='12' sm='12' md='12' lg='6'>
								<Row>
									<Col xs='4'>
										<label className="col-form-label">Faks </label>
									</Col>
									<Col xs='8' className="form-group">
										<input className="form-control"
											   type="text"
											   name="fax"
											   value={externalCustomerAddress.fax}
											   onChange={(e) => this.props.onChangeExternalCustomerAddress(e)}/>
									</Col>
								</Row>
							</Col>

							<Col xs='12' sm='12' md='12' lg='6'>
								<Row>
									<Col xs='4'>
										<label className="col-form-label">Mahalle/Cadde</label>
									</Col>
									<Col xs='8' className="form-group">
										<input className="form-control"
											   type="text"
											   name="streetName"
											   value={externalCustomerAddress.streetName}
											   onChange={(e) => this.props.onChangeExternalCustomerAddress(e)}/>
									</Col>
								</Row>
							</Col>
						</Row>

						<Row>
							<Col xs='12' sm='12' md='12' lg='6'>
								<Row>
									<Col xs='4'>
										<label className="col-form-label" style={{whiteSpace: 'nowrap'}}>Bina Adı </label>
									</Col>
									<Col xs='8' className="form-group">
										<input className="form-control"
											   type="text"
											   name="buildingName"
											   value={externalCustomerAddress.buildingName}
											   onChange={(e) => this.props.onChangeExternalCustomerAddress(e)}/>
									</Col>
								</Row>
							</Col>

							<Col xs='12' sm='12' md='12' lg='6'>
								<Row>
									<Col xs='4'>
										<label className="col-form-label" style={{whiteSpace: 'nowrap'}}>Bina No </label>
									</Col>
									<Col xs='8' className="form-group">
										<input className="form-control"
											   type="text"
											   name="buildingNo"
											   value={externalCustomerAddress.buildingNo}
											   onChange={(e) => this.props.onChangeExternalCustomerAddress(e)}/>
									</Col>
								</Row>
							</Col>
						</Row>

						<Row>
							<Col xs='12' sm='12' md='12' lg='6'>
								<Row>
									<Col xs='4'>
										<label className="col-form-label" style={{whiteSpace: 'nowrap'}}>Daire No </label>
									</Col>
									<Col xs='8' className="form-group">
										<input className="form-control"
											   type="text"
											   name="postalAddressRoom"
											   value={externalCustomerAddress.postalAddressRoom}
											   onChange={(e) => this.props.onChangeExternalCustomerAddress(e)}/>
									</Col>
								</Row>
							</Col>

							<Col xs='12' sm='12' md='12' lg='6'>
								<Row>
									<Col xs='4'>
										<label className="col-form-label" style={{whiteSpace: 'nowrap'}}> Posta Kodu </label>
									</Col>
									<Col xs='8' className="form-group">
										<input className="form-control"
											   type="text"
											   name="postalZone"
											   value={externalCustomerAddress.postalZone}
											   onChange={(e) => this.props.onChangeExternalCustomerAddress(e)}/>
									</Col>
								</Row>
							</Col>
							<Col xs='12' sm='12' md='12' lg='6'>
								<Row>
									<Col xs='4'>
										<label className="col-form-label" style={{whiteSpace: 'nowrap'}}> Bayi No </label>
									</Col>
									<Col xs='8' className="form-group">
										<input className="form-control"
											   type="text"
											   name="branchNo"
											   maxLength={255}
											   value={externalCustomerAddress.branchNo}
											   onChange={(e) => this.props.onChangeExternalCustomerAddress(e)}/>
									</Col>
								</Row>
							</Col>
						</Row>
					</ModalBody>

					< ModalFooter>
						<nav className="row col-sm-12">
							<div className="col-3">
								<button type="button" data-toggle="tooltip" data-placement="bottom"
										style={
											{
												background: 'linear-gradient(rgba(125, 125, 125, 0.57), rgb(111, 111, 111))',
												float:
													'left',
												padding:
													'9px 39px 9px 13px'
											}
										}
										rel="tooltip"
										className="TekBtn vazgec btn-icon"
										onClick={() => this.cancelCurrentAddress()}>
									İptal
								</button>
							</div>
							<div className="col-6"></div>
							<div className="col-3">
								{this.props.editAddressMode === 'passive' &&
								<button type="button" data-toggle="tooltip" data-placement="bottom"
										style={{
											background: 'linear-gradient(rgba(159, 208, 55, 0.6), #9fd037)',
											float: 'right',
											padding: '10px 44px 10px 11px'
										}}
										rel="tooltip" className="TekBtn ekle btn-icon"
										onClick={() => this.addAddress()}>Ekle
								</button>}
								{this.props.editAddressMode === 'active' &&
								<button type="button" data-toggle="tooltip" data-placement="bottom"
										style={{
											background: 'linear-gradient(rgba(159, 208, 55, 0.6), #9fd037)',
											float: 'right',
											padding: '10px 44px 10px 11px'
										}}
										rel="tooltip" className="TekBtn ekle btn-icon"
										onClick={() => this.editAddress()}>Kaydet
								</button>}
							</div>
						</nav>
					</ModalFooter>
				</Modal>

				{this.state.alert &&
				<div className="row satirBasi">
					{this.state.alert}
				</div>
				}
			</div>
		)
	}
}

export default ExternalCustomerAddressInfo;
